
export const localStringToNumber = (s) => {
    return Number(String(s).replace(/[^0-9.,-]+/g, ""));
};

export const formatCurrency = (value, currencyCode) => {
    const options = {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    return value.toLocaleString(undefined, options);
};

export const formatPercentage = (value) => {
    const options = {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    return new Intl.NumberFormat(undefined, options).format(value / 100);
};